import React from 'react';

import { ClickableImageContainer } from '../ClickableImageContainer/ClickableImageContainer';
import { ImageObject } from '../ImageSection.types';

interface DetailImageProps {
  imageObject: ImageObject;
  onClick: React.MouseEventHandler;
  additionalImageCount?: number;
}

export const DetailImage: React.FunctionComponent<DetailImageProps> = ({ imageObject, onClick }: DetailImageProps) => {
  return <ClickableImageContainer imageObject={imageObject} onClick={onClick} />;
};
DetailImage.displayName = 'DetailImage';
